<template>
	<div class="headbox">
		<article class="top">
			<section class="topK ward flexC fl-bet">
				<div class="topL flexC">
					<el-dropdown @command="dropdown">
						<div class="dropdown_box">
							<div class="drop_item flexC"></div>
							<span class="el-dropdown-link">
								({{seltgmt}}){{showTime}}<i class="el-icon-arrow-down el-icon--right"></i>
							</span>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item :class="dropidx==index?'selected':''" :command="index"
									v-for="(item, index) in droplist"
									:key="index">{{item.gmt}}{{item.title}}</el-dropdown-item>

							</el-dropdown-menu>

						</div>
					</el-dropdown>
					<!-- <div class="topLn flexC topLnW" :class="istopLnW?'on':''" @click="topLnW()"> -->
					<!-- <span class="pciconfont icon-shijian"></span> -->
					<!--<p>( GMT+8 )</p>-->
					<!-- <p>(GMT+0800)</p> -->
					<!-- <p>(GMT{{TimeZone+'00'}})</p> -->
					<!-- ET-2024/03/19(WE)00:17:15 -->
					<!-- <p>ET-</p>
						<div class="showTime topLs topLs-btn">{{showTime}}</div>
						<div class="time-select scrollBar_com Huans" v-if="isselect" :style="{height: divHeight}">
							<div>
								<div v-for="(item, index) in droplist" :key="index"
									class="Item_wrapper__3ERId custom-dropdown-item flexC"
									:class="dropidx==index?'on':''" @click.stop="dropdown(index,item)">
									<div class="TimeDropdown_timeZone_GMT__3NgJN">
										<div class="">{{item.gmt}}</div>
									</div>
									<div>
										<div class="">{{item.title}}</div>
									</div>
								</div>
							</div>
						</div> -->
					<!-- </div> -->
					<!-- <div class="topLn flexC">
						<span class="pciconfont icon-anquanbaozhang"></span>
						<div class="topLs">
							<router-link to="/pctest">{{$t('message.LineDetection')}}</router-link>
						</div>
					</div> -->


					<!-- <div class="topLn flexC">
            <span class="pciconfont icon-kefu"></span>
            <div class="topLs">
              <router-link to="/pcmemberCenter">会员中心</router-link>
            </div>
          </div> -->
				</div>

				<div class="topR flexC">
					<div class="headfrbox flexC">
						<div @click="navigate('SportLive')" class="headfritem flexC">
							<img src="@/assets/pc/images/icon/video.png">
							<span>{{$t('message.video')}}</span>
						</div>
						<div @click="navigate('SportLive')" class="headfritem flexC">
							<img src="@/assets/pc/images/icon/zbicon.png">
							<span>{{$t('message.Sportslive')}}</span>
						</div>
						<!-- router-link :to="{name: 'pckefu'}" -->
						<a :href='`javascript:window.open("${kfurl}", "livechat", "height=630, width=600, toolbar= no,directions=no,alwaysRaised=yes,hotkeys =yes, menubar=no, scrollbars=no, resizable=no, location=no, status=no,top=100,left=300");`'
							class="headfritem flexC">
							<img src="@/assets/pc/images/icon/kficon.png">
							<span>{{$t('message.kefu')}}</span>
						</a>
						<!-- <div @click="navigate('pckefu')" class="headfritem flexC">
							<img src="@/assets/pc/images/icon/kficon.png" />
							<span>{{$t('message.kefu')}}</span>
						</div> -->
					</div>
					<div class="dropdown_box yydown">
						<el-dropdown @command="onSelect">
							<div class="drop_item langitem flexC">
								<img :src="Curlang.img" />
								<span>{{ Curlang.label }}</span>
								<i class="el-icon-arrow-down el-icon--right"></i>
							</div>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item :class="selected==index?'selected':''" :command="index"
									v-for="(item, index) in actions" :key="index">
									<div class="drop_item langitem flexC">
										<img :src="item.img" />
										<span>{{ item.label }}</span>
									</div>
								</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</div>

					<!-- 		<div class="hdcn flexC" @mouseover="hdcnafun" @mouseleave="hdcnfun">
						<a href="javascript:;" class="hdcna flexC fl-bet" :class="ishdshow?'on':''">
							<img :src="yyimg">
							<p>{{yytitle}}</p>
							<span class="pciconfont icon-fangxiang-you"></span>
						</a>
						<div class="hdcnK Huans" :style="{'display':ishdshow?'block':'none'}">
							<div class="hdcnF flex fl-bet Huans">
								<a v-for="(item, index) in actions" :key="index" @click="hdcnFayy(index,item)"
									href="javascript:;" class="hdcnFa flexC fl-bet Huans" :class="index==yyidx?'on':''">
									<i class="hdcnFI"></i><img :src="item.img">
									<p>{{item.title}}</p>
									<i class="hdcnFI"></i><img :src="item.img">
									<p>{{item.label}}</p>
								</a>
							</div>
						</div>
					</div> -->
				</div>

			</section>
		</article>
		<!-- header -->
		<!-- :style="{backgroundImage:darkmode?'url('+imageUrldarkbg+')':'url('+imageUrlbg+')'}" -->
		<!-- :style="{backgroundImage:'url('+imageUrldarkbg+')'}" -->
		<header  class="header" :style="{backgroundImage:darkmode?'url('+imageUrldarkbg+')':'url('+imageUrlbg+')'}">
			<div class="headK ward Huans flexC">
				<!-- logo  target="_blank"-->
				<router-link to="/pcindex" v-if="darkmode" class="hdlogo"><img
						src="@/assets/pc/images/icon/logo_h.png"></router-link>
				<router-link to="/pcindex" v-else class="hdlogo saoguang"><img
						src="@/assets/pc/images/icon/logo.png"></router-link>
				<div class="headK_right">
					<div class="headK_ul flexC">
						<!-- <div class="topLn flexC">
							<img :src="modeicon" id="ms_tab_icon">
							<div class="topLs" id="text">{{modetext}}</div>
						</div> -->
						<div v-if="!darkmode" @click.stop="changedark" class="headK_li flexC">
							<span class="headK_icon iconfontll icon-yewanyueliang"></span>
							<span class="headK_txt">{{$t('footer.dark')}}</span>
						</div>
						<div v-else @click.stop="changedark" class="headK_li flexC">
							<span class="headK_icon iconfontll icon-baitian"></span>
							<span class="headK_txt">{{$t('footer.byday')}}</span>
						</div>
						<div class="headK_sx">|</div>
						<router-link to="pcforgetpass" class="headK_li flexC">{{$t('message.forget')}}</router-link>
						<div class="headK_sx">|</div>
						<router-link :to="{name:'pcproblem', query: {id:2}}"
							class="headK_li flexC">{{$t('message.help')}}</router-link>
					</div>
					<!--未登录-->
					<div v-if="!isLogin" class="topR flexC">
						<div class="topRN loginuser flexC Huans">
							<span class="pciconfont icon-zhanghao"></span>
							<div @click="qmshowClick()" class="PhoneInput_dropdown">
								<div class="PhoneInput flexC fl-bet TcLogFS Huans">
									<div class="PhoneInput_icon__2rYuk">{{qmval}}</div>
									<img src="@/assets/pc/images/icon/Bro-sel.png" class="">
								</div>
								<div v-show="qmlistshow" class="dropdown-menu">
									<!-- <div class="dropdown-header Huans">
										<div class="PhoneInput_searchBar__28oua Huans">
											<img src="@/assets/pc/images/icon/search.svg"
												class="PhoneInput_searchIcon__2JYPG">
											<div class="PhoneInput_searchInput__CK5ms">
												<input type="tel" v-model="keys" name="searchInput"
													:placeholder="$t('message.Keysdesc')" value="">
											</div>
										</div>
									</div> -->
									<div class="PhoneInput_scrollBar__3NYCp scrollBar_com">
										<a v-for="(item, index) in qmList" :key="index" href="javascript:;"
											class="dropdown-item" :class="qmid==item.id?'active':''"
											@click="qmTab(item, index)">
											<div class="PhoneInput_countryRow__3SPK6 Huans flexC">
												<div>
													<!-- 	<img :src="item.img" class="PhoneInput_icon__2rYuk"> -->
												</div>
												<div class="PhoneInput_countryName__2r_30">{{item.label}}</div>
												<div class="PhoneInput_countryCallingCode__1McnF">{{item.value}}
												</div>
											</div>
										</a>
									</div>
								</div>
							</div>
							<input type="text" :placeholder="$t('message.phone')+'/'+$t('message.userID')"
								v-model="account" class="topRI Huans">
						</div>
						<div class="topRN flexC Huans">
							<span class="pciconfont icon-mima2"></span>
							<input type="password" :placeholder="$t('message.password')" v-model="password"
								class="topRI Huans">
							<!-- 忘记密码 -->
							<!-- <a href="javaScript:;" class="topRNa">{{$t('message.forget')}}</a> -->
						</div>
						<!-- <div class="topRN topRNw flexC Huans">
							<span class="pciconfont icon-anquan1"></span>
							<input type="text" :placeholder="$t('message.yzm')" v-model="twcode" class="topRI Huans">
						</div> -->
						<!-- <a @click="refreshCode" href="javaScript:;" class="topMa"><img :src="imgcode"></a> -->
						<!-- <a  href="javaScript:;" class="topBut topButDL">{{$t('message.login')}}</a> -->
						<el-button @click="gologin()" :disabled="submitStatus" :loading="submitStatus"
							class="topBut topButDL">{{$t('message.login')}}</el-button>
						<!-- <router-link class="topBut topButDL" to="/pclogin">登录</router-link> -->
						<router-link class="topBut topButZC" to="/pcregister">{{$t('message.register')}}</router-link>
					</div>
					<!--登录后-->
					<div v-else class="topR flexC">
						<div class="MenuHDE flexC">
							<span class="money_txt">{{$t('message.mywallet')}}</span>
							<span class="money">￥{{userInfo.money}}</span>
							<span @click.stop="RefreshM()" class="sx_money iconfontll icon-gengxin_huaban"
								:class="{'rotating': isRotating }"></span>
						</div>
						<router-link class="bordBtn flexC" to="/pcrecharge">
							<span class="bordBtn_icon iconfontll icon-kabao"></span>
							<span>{{$t('message.recharge')}}</span>
						</router-link>
						<router-link class="bordBtn flexC" to="/pcwithdraw">
							<span class="bordBtn_icon iconfontll icon-kabao1"></span>
							<span>{{$t('message.withdraw')}}</span>
						</router-link>
						<div class="MenuHDsx" :class="{'greyBtn': !status}" @click="headretrieve()">
							{{$t('message.onerecycle')}}
						</div>
						<el-dropdown>
							<div class="MenuHDN flexC">
								<div class="TU_Tx flexC">
									<router-link class="TU_img" to="/pcvip">
										<img class="avatar_img" :src="userInfo.photo">
									</router-link>

								</div>
								<div class="TU_right">
									<div class="MenuHDE_name flexC">{{userInfo.nickname}}</div>
									<div class="viptopbox ">
										<!-- iconfontll icon-vip -->
										<span class="viptxt viptxt_icon">VIP</span>
										<span class="viptxt">{{userInfo.level_id}} </span>
										<!-- <img src="@/assets/pc/images/icon/v8.png"> -->
									</div>
								</div>
								<span class="TU_Fn">
									<span class="downicon iconfontll icon-xiangxia"></span>
								</span>
							</div>
							<!-- hover nav -->
							<el-dropdown-menu class="loadnavul" slot="dropdown">
								<el-dropdown-item>
									<router-link class="loadnavli Huans" to="/pcmemberCenter">
										<span class="loadnav_icon iconfontll icon-gerenzhongxin1"></span>
										<span>{{$t('message.mycenter')}}</span>
									</router-link>
								</el-dropdown-item>
								<el-dropdown-item>
									<router-link class="loadnavli Huans" to="/pcmessage">
										<span class="loadnav_icon iconfontll icon-xiaoxi1"></span>
										<span>{{$t('message.messages')}}</span>
									</router-link>
								</el-dropdown-item>
								<el-dropdown-item>
									<a href="javascript:;" class="loadnavli Huans" @click="loginout()">
										<span class="loadnav_icon iconfontll icon-tuichu"></span>
										<span>{{$t('message.loggingout')}}</span>
									</a>
								</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</div>


				</div>
			</div>
			<nav class="menu Huans ward flexC fl-bet">
				<div class="menuleft flexC">
					<router-link to="/pcindex" class="nava flexC fl-cen" :class="link=='index'?'on':''"><span
							class="pciconfont icon-shouye"></span>
						<p>{{$t('message.home')}}</p>
					</router-link>
					<router-link to="/pcsports" class="nava flexC fl-cen" :class="link=='sports'?'on':''"><span
							class="pciconfont icon-a-tiyu1"></span>
						<p>{{$t('message.sports')}}</p>
						<img class="menu-hot" src="@/assets/pc/images/icon/hot.png" alt="">
					</router-link>
					<router-link to="/pconsite" class="nava flexC fl-cen" :class="link=='onsite'?'on':''"><span
							class="pciconfont icon-zhenren"></span>
						<p>{{$t('message.live')}}</p>
						<img class="menu-hot" src="@/assets/pc/images/icon/hot.png" alt="">
					</router-link>
					<router-link to="/pcChess" class="nava flexC fl-cen" :class="link=='Chesscards'?'on':''"><span
							class="pciconfont icon-puke"></span>
						<p>{{$t('message.chess')}}</p>
					</router-link>
					<router-link to="/pcegames" class="nava flexC fl-cen" :class="link=='egames'?'on':''"><span
							class="pciconfont icon-dianzi"></span>
						<p>{{$t('message.slot')}}</p>
					</router-link>
					<router-link to="/pclottery" class="nava flexC fl-cen" :class="link=='lottery'?'on':''"><span
							class="pciconfont icon-taiqiu"></span>
						<p>{{$t('message.lottery')}}</p>
						<img class="menu-hot" src="@/assets/pc/images/icon/hot.png" alt="">
					</router-link>
					<router-link to="/pcfishing" class="nava flexC fl-cen" :class="link=='fishing'?'on':''"><span
							class="pciconfont icon-a-33"></span>
						<p>{{$t('message.fishing')}}</p>
					</router-link>
				</div>
				<div class="menuright flexC">
					<router-link to="/pcactivity" class="nava navafr flexC fl-cen"
						:class="link=='activity'?'on':''"><span class="pciconfont icon-liwu"></span>
						<p>{{$t('message.activity')}}</p>
					</router-link>
				</div>
				<!-- <div>{{$t('message.hello')}}</div> -->
			</nav>
		</header>
		<!-- end header -->
		<!-- 回收弹窗-->
		<el-dialog @close="closehspopus" :title="$t('message.Recovery')" width="500px" :visible.sync="ispopus"
			:show-close="true" :close-on-click-modal="true" :modal-append-to-body="false" class="Huans">
			<div class="popuscon">
				<div class="recoverbox">
					<div class="recoveritem" v-for="(item, index) in platlist" :key="index">
						<div class="recovercont">
							<div class="recovername">{{ item.title }}</div>
							<div class="restateimg">
								<img class="stateimg" :src="item.stateimg" mode=""></img>
							</div>
						</div>
					</div>
				</div>
				<div class="botmbtn">
					<div class="recoverbtn progress_end" v-if="recoverstate" @click.stop="ispopus=false">确定
					</div>
					<div class="recoverbtn progress_start" v-else>
						程序执行中
						<span id="dot"></span>
					</div>
				</div>
			</div>
		</el-dialog>
		<!--回收弹窗end  -->
	</div>
</template>
<script>
	// import { timeZoneObject } from '@/assets/pc/js/zoneData.js'
	import {
		queryConfig,
		actLoginout,
		// queryImgcode,
		postLogin,
		sendSms,
		getAreaCodes,
		getUserInfo,
		queryGameplats,
		Recovergamemoney,
		getLangs
	} from "@/api/urls";
	export default {
		name: 'Header',
		inject: [
			'reload'
		],
		props: {
			// cate: {
			// 	type: Object,
			// 	default: () => ({})
			// },
			// type: {
			// 	type: Number,
			// 	default: 1
			// },
			link: {
				type: String,
				default: ""
			}
		},
		data() {
			return {
				isLogin: false, //是否登录
				userInfo: {
					money: 0,
					photo: 0,
					nickname: '',
					level_id: 1,
				}, //用户信息
				darkmode: false, //是否夜间模式
				modeicon: require('@/assets/pc/images/icon/sun.svg'),
				modetext: "夜间模式",
				showTime: '',
				istopLnW: false,
				droplist: [{
					id: 1,
					gmt: "GMT+08:00",
					title: "中国/北京",
					fgh: "-1100"
				}, {
					id: 2,
					gmt: "GMT+00:00",
					title: "英国/伦敦"
				}, {
					id: 3,
					gmt: "GMT+06:00",
					title: "中国/乌鲁木齐"
				}, {
					id: 4,
					gmt: "GMT+03:00",
					title: "俄罗斯/莫斯科"
				}, {
					id: 5,
					gmt: "GMT+07:00",
					title: "泰国/曼谷"
				}, {
					id: 6,
					gmt: "GMT+09:00",
					title: "日本/东京"
				}, {
					id: 7,
					gmt: "GMT-02:00",
					title: "美国/华盛顿"
				}, {
					id: 8,
					gmt: "GMT-05:00",
					title: "美国/纽约"
				}, {
					id: 9,
					gmt: "GMT-08:00",
					title: "洛杉矶/温哥华"
				}, {
					id: 10,
					gmt: "GMT-09:00",
					title: "美国/朱诺"
				}, {
					id: 11,
					gmt: "GMT-11:00",
					title: "美国本土外小岛屿/中途岛"
				}],
				dropidx: -1,
				seltgmt: "GMT+08:00",
				isselect: false, //是否显示时间列表
				TimeZone: "", //时区
				divHeight: -20,
				qmlistshow: false, //是否显示区码列表
				qmList: [{
					id: 4,
					label: "美国",
					value: "+1",
				}],
				qmindex: 5,
				qmid: 11,
				qmval: "+86", //+86
				account: "",
				password: "",
				twcode: '', //图文验证码
				imgcode: '', //图形验证码图片
				Config: {},
				kfurl: '', //客服
				// imageUrlbg: require('@/assets/pc/images/pic/acv_ban.jpg'),
				imageUrlbg: "", //头部背景图片
				imageUrldarkbg: "", //头部黑夜背景图片
				ishdshow: false, //是否显示语言框
				selected: 0,
				actions: [],
				flag: false,
				showPopover: false,
				Curlang: {
					label: '',
					img: "",
					value: '',
				},
				submitStatus: false, //按钮状态
				status: true, //一键回收状态
				ispopus: false, //回收弹窗弹窗
				platlist: [], //平台列表
				number: 0, //已回收个数
				recoverstate: false, //是否回收按钮
				isrecoverlist: [], //是否全部回收
				isRotating: false, //是否刷新钱包图标转动

			}
		},
		created() {
			var that = this;
			that.getSystem();
			that.getAreaCodes(); //国家手机号区码
			//获取语言列表
			that.getLanguages();
			// 判断是否登录
			if (that.$store.state.token != '') {
				that.isLogin = true;
				// that.getTransferStatus(); //查询一键转出的状态
				that.userInfo = that.$store.getters['getUserInfo'];
				// that.userInfo = that.$store.state.userInfo;
				// console.log(that.userInfo, "that.userInfo")
				that.getUserInfo();
				// that.status = that.$store.state.TransferStatus; //一键回收状态
			} else {
				that.isLogin = false;
				// that.getImgCode() //获取图形验证码
			}
			// 获取时区
			var TimeZone = that.$store.state.TimeZone;
			that.TimeZone = TimeZone;
			console.log(TimeZone, "TimeZone")
			if (TimeZone != "" && TimeZone != undefined) {
				that.formatToDateTimeFn(TimeZone) //时区
				that.dropidx = that.$store.state.dropidx;
				that.seltgmt = that.droplist[that.dropidx].gmt;
			} else {
				that.gettimeinfo() //获取时间
			}
			// 获取黑白模式
			var darkmodeval = that.$store.state.darkmode;
			console.log("darkmodeval", darkmodeval)
			if (darkmodeval != null) {
				that.darkmode = darkmodeval;
				if (darkmodeval) {
					that.modeicon = require('@/assets/pc/images/icon/sun.svg');
					that.modetext = "夜间模式";
					// 挂载后给body添加类名
					document.body.classList.add('darkmode');
					document.head.querySelector("#theme-link").setAttribute("href", `./static/style/theme-dark.css`);
				} else {
					that.modeicon = require('@/assets/pc/images/icon/moon.svg');
					that.modetext = "白天模式";
					// 挂载后给body添加类名
					document.body.classList.remove('darkmode');
					document.head.querySelector("#theme-link").setAttribute("href", `./static/style/theme-light.css`);
				}
			}

			// console.log(that.GLOBAL.token, "token_Header", darkmodeval, that.darkmode)
		},
		mounted() {
			// 在组件挂载后，触发一次默认的选中事件
			// this.onSelect(this.selected);
		},
		methods: {
			//跳转地址
			navigate(path) {
				//判断是否登录
				if (this.isLogin == false) {
					this.$message.error(this.$t('message.plogin'));
					return false;
				}
				if (path == "SportLive") {
					this.$message.error("暂未开放，请耐心等待");
					return false;
				}
				this.$router.push({
					path: path
				});

			},
			// 刷新金额
			RefreshM() {
				this.isRotating = true;
	
				// this.$toast({
				// 	type: 'loading',
				// 	message: this.$t('message.refreshing') + '...',
				// 	duration: 0,
				// 	forbidClick: true, //禁止背景点击
				// });

				this.getUserInfo();
				// this.$toast.clear();
				setTimeout(() => {
					this.isRotating = false;//关闭转动刷新图片
				}, 500)
				// this.$toast(this.$t('message.refreshend'));
			},
			// 获取国家手机号
			getAreaCodes() {
				var params = {
					'lang': this.$store.state.lang,
				}
				getAreaCodes(params).then(({
					code,
					data
				}) => {
					if (code === 200) {
						this.qmList = data;
						// var actions = [];
						// data.map((item, index) => {
						// 	var conts = {
						// 		text: item['label'] + item['value']
						// 	};
						// 	actions.push(conts);
						// })
						// this.country = actions[0];
					}
				})
			},
			// 区码切换选择
			qmTab(item, index) {
				var that = this;
				that.qmindex = index;
				that.qmid = item.id;
				// that.qmval = item.label + ' ' + item.value;
				that.qmval = item.value;
			},
			// 是否显示区码列表
			qmshowClick() {
				var that = this;
				that.qmlistshow = !that.qmlistshow;
			},
			//选择国际化
			// item, index
			onSelect(index) {
				var item = this.actions[index];
				this.selected = index;
				console.log(item);
				// console.log(index);
				this.flag = !this.flag;
				if (item.value == 'CN') {
					this.$i18n.locale = 'zh';
					this.$store.commit('setIlang', 'zh')
				} else if (item.value == 'TW') {
					this.$i18n.locale = 'tw';
					this.$store.commit('setIlang', 'tw')
				} else if (item.value == 'EN') {
					this.$i18n.locale = 'en';
					this.$store.commit('setIlang', 'en')
				} else if (item.value == 'VN') {
					// 越南语跳转到越南网站
					this.$i18n.locale = 'vn';
					this.$store.commit('setIlang', 'vn')
					// this.$router.push({
					// 				path: '/web',
					// 				query: {
					// 					url: data.url
					// 				}
					// 			})
					// 			// window.location.href = data.url;
					// this.showPopover = false;
					// return false
				} else if (item.value == 'KO') {
					this.$i18n.locale = 'ko';
					this.$store.commit('setIlang', 'ko')
				} else if (item.value == 'TH') {
					this.$i18n.locale = 'th';
					this.$store.commit('setIlang', 'th')
				} else {
					this.$message.error('您所在地区不支持！');
					this.showPopover = false;
					return false
				}
				this.Curlang = item;
				this.$store.commit('setLang', item.value)
				this.showPopover = false;
				// this.$router.go(0);
				this.reload() //刷新页面
			},
			//获取语言列表
			getLanguages() {
				var params = {
					'lang': this.$store.state.lang,
				}
				getLangs(params).then(({
					code,
					data
				}) => {
					if (code === 200) {
						// console.log(data, "data")
						this.actions = data;
						this.Curlang = data[0];
						// 获取语言
						var langval = this.$store.state.lang;
						for (var i in this.actions) {
							if (this.actions[i].value == langval) {
								this.selected = i;
								this.Curlang = this.actions[i];
								console.log(this.Curlang, "获取语言key")
							}
						}
						//默认进入的兼容处理
						if (this.Curlang.value == '') {
							this.Curlang = this.actions[0];
							this.selected = 0;
							console.log(this.Curlang, "获取默认语言key")
							this.$i18n.locale = 'zh';
							this.$store.commit('setIlang', 'zh')
							this.$store.commit('setLang', 'CN')

						}
					}
				})
			},
			// 时间
			gettimeinfo() {
				var that = this;
				var t = null;
				t = setTimeout(time, 1000); //开始运行
				function time() {
					clearTimeout(t); //清除定时器
					var dt = new Date();
					var y = dt.getFullYear();
					var mt = dt.getMonth() + 1;
					if (parseInt(mt) < 10) {
						mt = '0' + mt;
					}
					var day = dt.getDate();
					if (parseInt(day) < 10) {
						day = '0' + day;
					}
					var h = dt.getHours();
					var m = dt.getMinutes();
					var s = dt.getSeconds();
					if (parseInt(h) < 10) {
						h = '0' + h;
					}
					if (parseInt(m) < 10) {
						m = '0' + m;
					}
					if (parseInt(s) < 10) {
						s = '0' + s;
					}
					// console.log(dt,"dt")
					// that.showTime = day + "/" + mt + "/" + y + '  ' + h + ":" + m + ":" + s;
					that.showTime = y + "/" + mt + "/" + day + '  ' + h + ":" + m + ":" + s;
					t = setTimeout(time, 1000); //设置定时器，循环运行
				}
			},
			//图文验证码
			getImgCode() {
				// queryImgcode().then(({
				// 	code,
				// 	data
				// }) => {
				// 	if (code === 200) {
				// 		this.imgcode = data.imageCode;
				// 	}
				// })
			},
			refreshCode() {
				this.getImgCode();
			},
			// 点击时间显示时间列表
			topLnW() {
				var that = this;
				if (!that.istopLnW) {
					that.istopLnW = true;
					that.isselect = true;
				} else {
					that.istopLnW = false;
					that.isselect = false;
				}
			},

			// 点击时间列表的每项
			dropdown(index) {
				var that = this;
				that.dropidx = index;
				that.isselect = false;
				var item = that.droplist[index];
				var gmt = item.gmt;
				that.seltgmt = item.gmt;
				let asderf = gmt.indexOf('GMT'); //加
				let fghdfgd = gmt.substring(asderf + 3, asderf + 6); //asderf+9
				// let b = fghdfgd.replace(':', '');//asderf+9
				console.log(gmt, "gmt", fghdfgd)
				var timezone = fghdfgd; //8目标时区时间，东八区
				that.$store.commit('setDropidx', index) //缓存上时区索引
				that.$store.commit('setTimeZone', timezone) //缓存上时区
				that.formatToDateTimeFn(timezone) //时区方法
				that.reload() //刷新页面
			},

			// 封装方法时区
			formatToDateTimeFn(timezone) {
				var that = this;
				var timezone = timezone; //8目标时区时间，东八区

				var t = null;
				t = setTimeout(time, 1000); //开始运行
				function time() {
					clearTimeout(t); //清除定时器
					var offset_GMT = new Date().getTimezoneOffset(); // 本地时间和格林威治的时间差，单位为分钟
					var nowDate = new Date().getTime(); // 本地时间距 1970 年 1 月 1 日午夜（GMT 时间）之间的毫秒数
					var targetDate = new Date(nowDate + offset_GMT * 60 * 1000 + (timezone) * 60 * 60 * 1000);
					var timelen = targetDate.getTime();
					var targetDate1 = targetDate.toLocaleString()
					// console.log("时区现在是：" + targetDate1, "timezone", timezone);
					// 运行时间
					var dt = new Date(timelen);
					// console.log(dt,"dt","timelen",timelen)
					var y = dt.getFullYear();
					var mt = dt.getMonth() + 1;
					if (parseInt(mt) < 10) {
						mt = '0' + mt;
					}
					var day = dt.getDate();
					if (parseInt(day) < 10) {
						day = '0' + day;
					}
					var h = dt.getHours();
					var m = dt.getMinutes();
					var s = dt.getSeconds();
					if (parseInt(h) < 10) {
						h = '0' + h;
					}
					if (parseInt(m) < 10) {
						m = '0' + m;
					}
					if (parseInt(s) < 10) {
						s = '0' + s;
					}
					// console.log(dt,"dt")
					that.showTime = day + "/" + mt + "/" + y + '  ' + h + ":" + m + ":" + s;
					t = setTimeout(time, 1000); //设置定时器，循环运行
				}
			},

			// toSub2 () {
			//      this.$router.push({ path: '/sub2' })
			//    },
			// 登录
			gologin() {
				var that = this;
				that.submitStatus = true;
				if (that.account == '') {
					that.$message.error('请输入手机号或用户ID');
					that.submitStatus = false;
					return false
				}
				if (that.password == '') {
					that.$message.error('请输入密码');
					that.submitStatus = false;
					return false
				}
				// if (that.twcode == '') {
				// 	that.$message.error('请输入验证码');
				// that.submitStatus = false;
				// 	return false
				// }
				var params = {
					"area_code": that.qmval,
					"username": that.account,
					"password": that.password,
				}
				console.log("params", params)
				postLogin(params).then(({
					code,
					data,
					msg
				}) => {
					if (code === 200) {
						that.$message.success('登录成功');
						that.isLogin = true;
						// that.userInfo = data.user;
						that.$store.commit('setToken', data)
						// that.$store.commit('setUserInfo', data.user)
						that.$store.commit('setIslookpop',false)
						that.getUserInfo();
						that.submitStatus = false;
						setTimeout(() => {
							that.$router.push({
								name: 'pcindex'
							});
						}, 2000)
						that.reload() //刷新页面
					} else {
						that.$message.error(msg);
						that.submitStatus = false;
						return false;
					}
				})
			},
			// 获取用户信息
			getUserInfo() {
				//判断是否登录
				if (this.$store.state.token == '') {
					this.isLogin = false;
					return false;
				}
				var params = {
					'lang': this.$store.state.lang,
				}
				getUserInfo(params).then(({
					code,
					data
				}) => {
					if (code === 200) {
						this.isLogin = true;
						this.userInfo = data;
						this.$store.commit('setUserInfo', data)
					} else {
						console.log(code, "code2")
						this.isLogin = false;
						this.$store.commit('setLoginOut');
					}
				})
			},
			// 退出登录
			loginout() {
				var that = this;
				var params = {
					'lang': this.$store.state.lang,
				}
				actLoginout(params).then(({
					code,
					data
				}) => {
					if (code === 200) {
						that.isLogin = false;
						// that.getImgCode() //获取图形验证码
						that.$store.commit('setLoginOut');
						that.$message({
							message: '退出成功',
							type: 'success'
						});
						// that.reload() //刷新页面
						// setTimeout(() => {
							that.$router.push({
								name: 'pcindex'
							});
						// }, 1000)
					} else {
						// that.$message({
						//   message: '退出失败',
						//   type: 'error'
						// });
					}
				})
			},
			// 选择语言
			hdcnafun(e) {
				var that = this;
				// console.log(e, "移入")
				that.ishdshow = true;
				// console.log(that.ishdshow, "移入1")
			},
			hdcnfun(e) {
				var that = this;
				// console.log(e, "移出")
				that.ishdshow = false;
				// console.log(that.ishdshow, "移出1")
			},

			// 切换黑夜
			changedark() {
				var that = this;
				var darkmodeval = !that.darkmode;
				console.log("darkmodeval", darkmodeval)
				if (!darkmodeval) {
					that.darkmode = false;
					that.modeicon = require('@/assets/pc/images/icon/moon.svg');
					that.modetext = "白天模式";
					that.$store.commit('setDarkmode', false)
					// 挂载后给body添加类名
					document.body.classList.add('darkmode');
					document.head.querySelector("#theme-link").setAttribute("href", `./static/style/theme-light.css`);
				} else {
					that.darkmode = true;
					that.modeicon = require('@/assets/pc/images/icon/sun.svg');
					that.modetext = "夜间模式";
					that.$store.commit('setDarkmode', true)
					// 挂载后给body添加类名
					document.body.classList.remove('darkmode');
					document.head.querySelector("#theme-link").setAttribute("href", `./static/style/theme-dark.css`);

					// that.modeicon = require('@/assets/wap/images/icon/moon.svg');
					// that.modetext = "白天模式";
					// setTimeout(function(){
					//   location.reload() //刷新页面
					// },1000)
				}
				// that.$router.go(0);
				that.reload() //刷新页面
				// location.reload()//刷新页面
			},
			// 一键回收
			headretrieve() {
				if (this.$store.state.token == '') {
					this.$message.error(this.$t('message.plogin'));
					return false;
				}
				this.ispopus = true;
				this.gethsGameplats();
			},
			//回收弹窗关闭事件
			closehspopus() {
				console.log("close关闭弹窗")
				this.getUserInfo();
			},
			//获取回收游戏平台列表
			gethsGameplats() {
				var params = {
					'lang': this.$store.state.lang,
				}
				queryGameplats(params).then(({
					code,
					data
				}) => {
					if (code === 200) {
						if (data.length > 0) {
							//初始化个数值
							this.number = 0;
							this.platlist = data;
							for (var i in this.platlist) {
								this.platlist[i].stateimg = require('@/assets/pc/images/icon/zload.gif');
								if (!this.ispopus) {
									break;
								}
								// 0维护，1正常，2禁用
								if (this.platlist[i].status == 1) {
									// 一键回收
									// console.log("回收中")
									this.recovergamemoney(this.platlist[i].apiname, i, this.platlist[i].status);
								} else if (this.platlist[i].status == 0) {
									this.platlist[i].stateimg = require('@/assets/pc/images/icon/yellowh.png');
									this.number = this.number + 1;
								}
							}
							// this.platlist = list;
							this.$forceUpdate(); //强制更新
						}

					}
				})
			},
			// 一键回收游戏余额
			recovergamemoney(type, i, status) {
				if (!this.ispopus) {
					return false;
				}
				// if(status == 1)
				// {
				// 	this.platlist[i].stateimg =require('@/assets/wap/images/icon/redx.png');
				// 	return false;
				// }
				var params = {
					"type": type, //游戏平台，AB,AG,LEG,IA,IG
					'lang': this.$store.state.lang,
				}
				Recovergamemoney(params).then(({
					code,
					data,
					msg
				}) => {

					if (code === 200) {
						this.platlist[i].stateimg = require('@/assets/pc/images/icon/lvdui.png');
					} else {
						this.platlist[i].stateimg = require('@/assets/pc/images/icon/redx.png');
						// this.$message.error(msg);
					}

					// 执行状态
					this.isrecover(i);
					this.$forceUpdate(); //强制更新

				})
			},
			// 是否回收
			isrecover(i) {
				let platlist = this.platlist;

				this.number = this.number + 1;
				console.log(i, this.number);
				// console.log('length', platlist.length);
				if (platlist.length == this.number) {
					// 全部回收
					this.recoverstate = true;
				} else {
					this.recoverstate = false;
				}
			},
			//获取cs链接
			getSystem() {
				var params = {
					'lang': this.$store.state.lang,
				}
				queryConfig(params).then(({
					code,
					data
				}) => {
					if (code === 200) {
						this.Config = data;
						this.kfurl = data.site_online;
						this.imageUrlbg = data.index_background; //头部白天背景
						this.imageUrldarkbg = data.index_black_background; //头部黑夜背景
						// console.log(data, "data")
					}
				})
			},
		}
	}
</script>

<style lang="less" scoped>
	.headfrbox {
		.headfritem {
			margin-left: 20px;

			img {
				width: 14px;
			}

			span {
				margin-left: 10px;
				font-size: 12px;
				color: var(--font-color);
			}
		}
	}

	.yydown {
		margin-left: 20px;
	}

	.langitem {
		img {
			width: 14px;
		}

		span {
			margin-left: 10px;
			font-size: 12px;
			color: var(--font-color);
		}
	}

	.greyBtn {
		background-image: linear-gradient(to right, #CCC 1%, #CCC);
	}

	// 回收弹窗
	.popuscon {
		width: 100%;
		font-size: 14px;
		box-sizing: border-box;

		/* 一键回收内容 */
		.recoverbox {
			width: 100%;
			display: flex;
			justify-content: flex-start;
			align-items: center;
			flex-wrap: wrap;
			// margin: 0 -10px 0 -10px;
			box-sizing: border-box;

			.recoveritem {
				width: 33.33333%;
				margin-bottom: 10px;
				padding: 0 10px;
				box-sizing: border-box;
				overflow: hidden;

				.recovercont {
					display: flex;
					justify-content: space-between;
					align-items: center;
					flex-direction: row;
					width: 100%;
					height: 30px;
					padding: 0 10px;
					background: var(--qbg-color);
					color: #597ef7;
					font-size: 14px;
					border-radius: 5px;
					overflow: hidden;
					box-sizing: border-box;
				}

				.recovername {
					margin-right: 5px;
				}

				span {
					vertical-align: middle;
				}

				.stateimg {
					width: 16px;
					height: 16px;
					vertical-align: middle;
				}
			}
		}

		.botmbtn {
			width: 100%;
			text-align: center;
			margin: 20px 0;

			.recoverbtn {
				display: inline-block;
				padding: 0 5px;
				width: 80%;
				height: 40px;
				line-height: 40px;
				color: #fff;
				font-size: 12px;
				text-align: center;
				border-radius: 5px;
				background-color: #2B7FF0;
			}

			#dot {
				height: 3px;
				width: 3px;
				display: inline-block;
				border-radius: 2px;
				animation: dotting 2.4s infinite step-start;
			}

			@keyframes dotting {
				25% {
					box-shadow: 4px 0 0 #fff;
				}

				50% {
					box-shadow: 4px 0 0 #fff, 14px 0 0 #fff;
				}

				75% {
					box-shadow: 4px 0 0 #fff, 14px 0 0 #fff, 24px 0 0 #fff;
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/pc/public/Header.vue